import { t } from '@lingui/macro';

import {
  DAYCARE,
  DOG_TRAINING,
  DROP_IN,
  GROOMING,
  OVERNIGHT_BOARDING,
  OVERNIGHT_TRAVELING,
  WALKING,
} from '@rover/constants/src/translations/services.constants';
import { PetType } from '@rover/types/src/Pet';

export const NETWORK_ERROR_MESSAGE = (): string =>
  t`Sorry, our servers are experiencing a “ruff” patch and we can’t load this page right now. Try again later.`;
export const SERVER_ERROR_MESSAGE = (): string =>
  t`Your network connection is weak or unavailable. Try again when you have a better connection.`;

export const MOBILE_MAX_WIDTH_LAYOUT = '450px';

export const FLOATING_FOOTER_PADDING = 32;

export const DEFAULT_DOG_SIZES = [
  {
    key: 'small',
    range: '0-15',
  },
  {
    key: 'medium',
    range: '16-40',
  },
  {
    key: 'large',
    range: '41-100',
  },
  {
    key: 'giant',
    range: '101+',
  },
];

export const DEFAULT_WEIGHT_LABEL = 'lbs';

export const MONTHS_TO_DISPLAY = 15;

export const AVAILABILITY_PREFERENCES_TYPE_IDS = () => ({
  [OVERNIGHT_BOARDING().type]: 1,
  [OVERNIGHT_TRAVELING().type]: 2,
  [DROP_IN().type]: 3,
  [DAYCARE().type]: 4,
  [WALKING().type]: 5,
  [GROOMING().type]: 6,
  [DOG_TRAINING().type]: 7,
});

export enum SITTER_PROFILE_EVENTSTREAM_EVENTS {
  READ_MORE_REVIEWS = 'owner-conversion-member-profile-read-more-reviews',
  SECTION_INTERACT = 'owner-conversion-member-profile-section-interact',
  SAVE_TO_FAVORITES = 'owner-conversion-sitter-profile-save-to-favorites',
  REMOVE_FROM_FAVORITES = 'owner-conversion-sitter-profile-remove-from-favorites',
  CHANGE_SERVICE = 'owner-conversion-member-profile-calendar-availability-type',
  CLICK_ON_CANCELLATION_POLICY = 'owner-conversion-member-profile-cancellation-policy',
  CLICK_ON_SITTER_PET = 'owner-conversion-member-profile-pets',
}

export enum SearchParamsPetType {
  CAT = PetType.CAT,
  DOG = PetType.DOG,
  DOG_CAT = `${PetType.DOG},${PetType.CAT}`,
  CAT_DOG = `${PetType.CAT},${PetType.DOG}`,
}

export type SearchParamsPetCounts = {
  selectedDogCount: number;
  selectedCatCount: number;
  selectedPuppyCount: number;
};
